import styled from "@emotion/styled";
import { GridItem } from "./layout/Grid";
import { pxToRem } from "../../design/utils";

export const EreaderMenuPanel = styled(GridItem)<{
  isOpen: boolean;
  fixedHeight?: boolean;
}>`
  ${({ fixedHeight }) =>
    fixedHeight
      ? `top: ${pxToRem(44)};
        position: sticky;
        height: calc(100vh - ${pxToRem(44)});
        height: calc(100dvh - ${pxToRem(44)});`
      : `flex-grow: 1;
        overflow-y: auto;
        `}
  overflow-y: auto;
  width: 100%;
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  flex-direction: column;
  color: ${({ theme }) => theme.colours.accent.dark._10};
  padding: 0;
  ${({ theme }) => theme.layers.relief.accent_20.shadow};
  scrollbar-width: thin;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
  grid-column: span 4;
  transition: transform 0.3s ease;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    ${({ fixedHeight }) =>
      fixedHeight
        ? `
    position: absolute;
    top: ${pxToRem(44)};
    left: 0;
    `
        : ``}
    width: 100%;
    background: white;
    z-index: 3;
    transform: ${({ isOpen }) =>
      isOpen ? "translateX(0)" : "translateX(-100%)"};
    grid-column: unset;
    ${({ theme }) => theme.layers.relief.accent_20.noShadow};
    max-width: 400px;
  }
`;
